import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-irenaeus',
  imports: [Link, RouterLink],
  templateUrl: './irenaeus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './irenaeus.scss',
})
export class Irenaeus {
  dynamicTitle = inject(TitleChange);

  constructor() {
    this.dynamicTitle.title('Irenaeus');
    this.dynamicTitle.description('Irenaeus of Lyons was an early Church father who wrote Against Heresies in order to dismantle other early Christian beliefs.');
  }
}
